import { render, staticRenderFns } from "./poi.vue?vue&type=template&id=012f8d38&lang=html&"
import script from "./poi.vue?vue&type=script&lang=js&"
export * from "./poi.vue?vue&type=script&lang=js&"
import style0 from "./poi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports